import { Typography as Text } from '@material-ui/core';

import type { RecordingFragment } from '@spotify/confidence-graphql';

import styles from './RecordingAnalysis.module.css';

export const hasAnalysisContent = (
  analysis: RecordingFragment['analysis'],
): boolean =>
  Boolean(
    analysis?.intent ||
      analysis?.summary ||
      analysis?.missedOpportunities.length,
  );

type RecordingAnalysisProps = {
  analysis?: RecordingFragment['analysis'];
};

export const RecordingAnalysis = ({ analysis }: RecordingAnalysisProps) => {
  if (!hasAnalysisContent(analysis)) return null;

  const missedOpportunities = analysis?.missedOpportunities ?? [];

  return (
    <div className={styles.root}>
      {analysis?.intent && (
        <div className={styles.item}>
          <Text variant="body2" color="textSecondary">
            Intent
          </Text>
          <Text variant="body2">{analysis.intent}</Text>
        </div>
      )}
      {analysis?.summary && (
        <div className={styles.item}>
          <Text variant="body2" color="textSecondary">
            Summary
          </Text>
          <Text variant="body2">{analysis.summary}</Text>
        </div>
      )}
      {missedOpportunities.length > 0 && (
        <div className={styles.item}>
          <Text variant="body2" color="textSecondary">
            Missed opportunities
          </Text>
          <ul className={styles.list}>
            {missedOpportunities.map(opportunity => (
              <li key={opportunity}>
                <Text variant="body2">{opportunity}</Text>
              </li>
            ))}
          </ul>
        </div>
      )}
      <Text
        variant="caption"
        color="textSecondary"
        className={styles.disclaimer}
      >
        Generated by AI from the session recording. May contain mistakes.
      </Text>
    </div>
  );
};
